export default function forceUniqueSizeToSizeFilters(uiState, mainIndex) {
  const allSizesFilters = uiState[mainIndex]?.refinementList?.sizes;
  const availableSizesFilters = uiState[mainIndex]?.refinementList?.available_sizes;
  if (!allSizesFilters?.length && !availableSizesFilters?.length) return uiState;

  const newUiState = { ...uiState };

  if (allSizesFilters?.length) {
    if (allSizesFilters.length === 1 && allSizesFilters[0] === "TU") {
      newUiState[mainIndex].refinementList.sizes = [];
    }

    if (!allSizesFilters.includes("TU")) {
      newUiState[mainIndex].refinementList.sizes.push("TU");
    }
  }

  if (availableSizesFilters?.length) {
    if (availableSizesFilters.length === 1 && availableSizesFilters[0] === "TU") {
      newUiState[mainIndex].refinementList.available_sizes = [];
    }

    if (!availableSizesFilters.includes("TU")) {
      newUiState[mainIndex].refinementList.available_sizes.push("TU");
    }
  }

  return newUiState;
}
